var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", [
        _c(
          "div",
          { style: _vm.boxStyle },
          [
            _vm.listStyle == 0
              ? [
                  _c(
                    "div",
                    { staticClass: "scroll_box" },
                    _vm._l(_vm.numShow, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "couponBg acea-row row-middle",
                          style: _vm.contentConfig,
                        },
                        [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { style: _vm.priceColorStyle }, [
                              _c("span", { staticClass: "price-icon" }, [
                                _vm._v("￥"),
                              ]),
                              _c("span", { staticClass: "price" }, [
                                _vm._v("80"),
                              ]),
                            ]),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("满500元可用"),
                            ]),
                          ]),
                          _c("div", { staticClass: "right" }, [_vm._v("领取")]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              : _vm._e(),
            _vm.listStyle == 1
              ? [
                  _c("div", { staticClass: "scroll_box" }, [
                    _c("div", { staticClass: "coupon1 acea-row row-middle" }, [
                      _c(
                        "div",
                        { staticClass: "list acea-row row-middle" },
                        _vm._l(_vm.numShow, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "item",
                              style: _vm.contentConfig,
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "money",
                                  style: _vm.priceColorStyle,
                                },
                                [
                                  _vm._m(0, true),
                                  _c("div", { staticClass: "tips" }, [
                                    _vm._v("满500可用"),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "sill",
                                  style: _vm.btnColorStyle,
                                },
                                [_vm._v("去领取")]
                              ),
                              _c("img", {
                                attrs: {
                                  src: require("../../../../assets/imgs/newVip02.png"),
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]
              : _vm._e(),
            _vm.listStyle == 2
              ? [
                  _c(
                    "div",
                    { staticClass: "scroll_box" },
                    _vm._l(_vm.numShow, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "couponBg acea-row row-middle couponBg-new",
                          style: _vm.contentConfig,
                        },
                        [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { style: _vm.priceColorStyle }, [
                              _c("span", { staticClass: "price-icon" }, [
                                _vm._v("￥"),
                              ]),
                              _c("span", { staticClass: "price" }, [
                                _vm._v("80"),
                              ]),
                            ]),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("满500元可用"),
                            ]),
                          ]),
                          _vm._m(1, true),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              : _vm._e(),
            _vm.listStyle == 3
              ? [
                  _c("div", { staticClass: "scroll_box" }, [
                    _c(
                      "div",
                      {
                        staticClass: "coupon5 acea-row row-middle",
                        style: _vm.boxBg,
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "list acea-row row-middle" },
                          _vm._l(_vm.numShow, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "item acea-row row-middle",
                                style: _vm.contentConfig,
                              },
                              [
                                _c("div", { staticClass: "left" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "money",
                                      style: _vm.priceColorStyle,
                                    },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v("¥"),
                                      ]),
                                      _vm._v("50"),
                                    ]
                                  ),
                                  _c("div", { staticClass: "tips" }, [
                                    _vm._v("满5000可用"),
                                  ]),
                                ]),
                                _vm._m(2, true),
                                _c("div", {
                                  staticClass: "roll",
                                  style: _vm.boxBg,
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "lable" }, [_vm._v("¥")]),
      _vm._v("70"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _vm._v("立"),
      _c("br"),
      _vm._v("即"),
      _c("br"),
      _vm._v("领"),
      _c("br"),
      _vm._v("取"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right acea-row row-center" }, [
      _c("div", { staticClass: "rightCon" }, [_vm._v("领取")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }